<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <alert-box ref="alertBox" class="spacer-l" />

        <bill-list
          :bills="bills"
          :loading="loadingData"
          class="spacer-bottom-xl"
          title="Histórico de pagamento"
          description="Veja todas as mensalidades que você já efetuou o pagamento."
        />
        <bill-list
          :bills="dischargeBills"
          v-if="dischargeBills.length > 0"
          :loading="loadingData"
          title="Quitação"
          description="Aqui você pode ver todos os seus contratos quitados"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AlertBox from 'components/zilla/alert-box';
import BillList from 'components/bill-list';
import Breadcrumb from 'components/breadcrumb';
import DashboardService from 'services/DashboardService';

export default {
  components: {
    AlertBox,
    BillList,
    Breadcrumb,
  },
  data() {
    return {
      bills: [],
      dischargeBills: [],
      loadingData: true,
      hasBills: true,
    };
  },
  computed: {
    ...mapState([
      'currentBilling',
    ]),
  },
  methods: {
    loadPaidBills() {
      DashboardService.getPaidBills(this.currentBilling.id)
        .then((bills) => {
          this.bills = this.filtetedBills(bills);
          this.dischargeBills = this.getDischargeBills(bills);

          if (bills.length === 0) {
            this.hasBills = false;
          }
        })
        .catch((error) => {
          this.$refs.alertBox.show(
            'danger', 'Erro inesperado',
            'Não foi possível carregar o histórico de pagamentos. Tente novamente mais tarde.',
          );

          this.$rollbar.error(error);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    getDischargeBills(bills) {
      const a = bills.filter((bill) => bill.bill_type === 'discharge');
      return a;
    },
    filtetedBills(bills) {
      return bills.filter((bill) => bill.bill_type !== 'discharge');
    },
  },
  mounted() {
    this.loadPaidBills();
    this.$tracker.logEvent('Viewed Payments History Page');
  },
};
</script>
